import { HStack, Spacer, VStack } from '@chakra-ui/react';
import { useState } from 'react';
import { ProductJSON } from '../../../../entities/Product';
import { CurrencyConversion } from '../../../../utils/currencies';
import { PrimaryButton } from '../../../primitives/buttons/PrimaryButton';
import { PriceLine } from './PriceLine';

interface Props {
  participants: number;
  submitLabel: string;
  product?: ProductJSON;
  isSubmitDisabled?: boolean;
  currencyConversion?: Omit<CurrencyConversion, 'source'>;
  onSubmit?(): Promise<void>;
  children: React.ReactNode;
}

export function Step(props: Props) {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const priceLine = props.product && props.participants > 0 ? (
    <PriceLine
      product={props.product}
      participants={props.participants}
      currencyConversion={props.currencyConversion}
    />
  ) : null;
  const isSubmitDisabled = props.isSubmitDisabled || isSubmitting || !props.onSubmit;

  async function onSubmit() {
    setIsSubmitting(true);
    await props.onSubmit?.();
    setIsSubmitting(false);
  }

  return (
    <VStack w="100%" spacing={5} mt={3}>
      <VStack w="100%" p={0} spacing={4}>
        { props.children }
      </VStack>

      <HStack w="100%" p={0}>
        { priceLine }
        <Spacer/>

        <PrimaryButton
          size="sm"
          isDisabled={isSubmitDisabled}
          isLoading={isSubmitting}
          onClick={onSubmit}
        >
          { props.submitLabel }
        </PrimaryButton>
      </HStack>
    </VStack>
  );
}